import { render, staticRenderFns } from "./AttachmentsAdder.vue?vue&type=template&id=2693f1f3&scoped=true"
import script from "./AttachmentsAdder.vue?vue&type=script&lang=js"
export * from "./AttachmentsAdder.vue?vue&type=script&lang=js"
import style0 from "./AttachmentsAdder.vue?vue&type=style&index=0&id=2693f1f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2693f1f3",
  null
  
)

export default component.exports